import { SITE } from "../data/site";
import { IconPin, IconInstagram } from "./Icons";

export const StickyBar = () => (
  <div
    className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-coal/95 backdrop-blur-md md:hidden"
    data-testid="sticky-order-bar"
  >
    <div className="grid grid-cols-3 divide-x divide-white/10 pb-[env(safe-area-inset-bottom)]">
      <a
        href="/menu/"
        data-testid="sticky-menu-link"
        className="flex h-14 items-center justify-center font-mono text-xs uppercase tracking-[0.18em] text-cream"
      >
        Menu
      </a>
      <a
        href="/lokasi/"
        data-testid="sticky-location-link"
        className="flex h-14 items-center justify-center gap-1.5 font-mono text-xs uppercase tracking-[0.18em] text-cream"
      >
        <IconPin className="h-4 w-4" />
        Outlet
      </a>
      <a
        href={SITE.instagram}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-instagram-link"
        className="flex h-14 items-center justify-center gap-1.5 bg-blood font-mono text-xs font-semibold uppercase tracking-[0.18em] text-cream"
      >
        <IconInstagram className="h-4 w-4" />
        Pesan
      </a>
    </div>
  </div>
);
